<template>
  <template v-for="item in text.content" :key="item.id" v-if="text.content">
    <component :blok="item" :is="item.type" />
  </template>
  <template v-else>
    <div v-html="text"></div>
  </template>
</template>
<script setup>
const props = defineProps({
  text: {
    type: [Object, String],
    default: "",
  },
});
</script>

<style lang="scss"></style>
